//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AddDocumentComment from "./add-document-comment";
import ProfileAvatar from "@Shared/components/general/profile-avatar";
import { isEmpty } from "lodash";
import { defineComponent } from "@vue/composition-api";
export default defineComponent({
  name: "DocumentComments",
  components: {
    AddDocumentComment,
    ProfileAvatar
  },
  props: {
    comments: {
      type: Object,
      required: true
    }
  },
  computed: {
    noComments() {
      return isEmpty(this.comments.byId);
    },
    commentPlaceholder() {
      return this.noComments ? this.$t("documents.writeAComment") : this.$t("documents.writeAReply");
    }
  },
  mounted() {
    this.scrollToEnd();
  },
  updated() {
    this.scrollToEnd();
  },
  methods: {
    handleCommentSubmit(data) {
      this.$emit("submit", data);
    },
    scrollToEnd() {
      this.$nextTick(() => {
        const content = this.$refs.messageBox;
        content.scrollTop = content.scrollHeight;
      });
    }
  }
});